import React, { Component, useCallback, useEffect, useState } from 'react';
import {
  getTokenForBrowser,
  isHMSAdminGroupMember,
  isInternalHMSUser,
  saveToken,
  verifyToken,
} from '../utils/auth/auth';
import { inject, observer } from 'mobx-react';

import HttpConstants from '../constants/HttpConstants';
import LoadingComponent from '../app/components/Loading';
import Paths from '../constants/RouteConstants';
import RouteConstants from '../constants/RouteConstants';
import UrlConstants from '../api/UrlConstants';
import { isEmpty } from 'lodash';
import { makeApiCallWithAuthentication } from '../api/ApiManager';
import { message } from 'antd';
import { parseHash } from '../utils/auth/auth0';
import { useMsal } from '@azure/msal-react';
import { withRouter } from 'react-router';

const RedirectScreen = (props) => {
  const { instance } = useMsal();

  const setRoute = useCallback(
    async (path) => {
      if (path !== RouteConstants.LOGIN) {
        const response = await makeApiCallWithAuthentication(
          UrlConstants.GET_USER_DETAILS.USECASE,
          HttpConstants.GET_METHOD
        );
        if (response.status === 200 && !isEmpty(response.data)) {
          const userDetails = response.data;
          props.rootStore.userStore.setUserDetails(userDetails);
		  updateSuperUserRoleToUser(instance, userDetails, false);
          if (
            userDetails.under_maintenance &&
            userDetails.under_maintenance === 'true'
          ) {
            props.history.push(RouteConstants.MAINTENANCE_PAGE);
            return;
          }
          // Call Hold Types Users API when not in maintenance
          else {
            const response = await makeApiCallWithAuthentication(
              UrlConstants.USERS_BY_HOLD_TYPE.USECASE,
              HttpConstants.GET_METHOD
            );
            if (response.status === 200) {
              const holdTypeUsers = response.data;
              props.rootStore.holdTypesUsersStore.setHoldTypesUsers(
                holdTypeUsers
              );
            }
          }
        } else {
          message.error('Cannot find user, please try later');
          console.log('Cannot find user. Error' + response.status);
          return;
        }
      }
      if (path === RouteConstants.MAINTENANCE_PAGE)
        path = RouteConstants.WATCHLIST_INVENTORY;
      props.history.push(path);
    },
    [
      props.history,
      props.rootStore.holdTypesUsersStore,
      props.rootStore.userStore,
    ]
  );

  useEffect(() => {
    const getJWTToken = async () => {
      let tokenResponse = await instance.acquireTokenSilent({
        account: instance.getActiveAccount(),
      });

      saveToken(tokenResponse.idToken);
      if (isInternalHMSUser(tokenResponse.idToken))
        setRoute(Paths.WATCHLIST_INVENTORY);
    };
    getJWTToken();
  }, [instance, setRoute]);

  const getParamsFromUrl = (urlSearchParams, param) => {
    return new URLSearchParams(urlSearchParams).get(param);
  };

  useEffect(() => {
    parseHash(async (err, result) => {
      if (result == null) {
        const token = await getTokenForBrowser();
        if (!token) {
          setRoute(RouteConstants.LOGIN);
          return;
        } else {
          let redirectionRoute = RouteConstants.WATCHLIST_INVENTORY;
          if (props.location.search) {
            const route = getParamsFromUrl(props.location.search, 'redirect');
            if (route) redirectionRoute = route;
          }
          setRoute(redirectionRoute);
          return;
        }
      }
      if (err) {
        console.error('Error signing in', err);
        setRoute(RouteConstants.LOGIN);
        return;
      }
      verifyToken(result.idToken).then(async (valid) => {
        if (valid) {
          saveToken(result.idToken, result.accessToken);
          setRoute(RouteConstants.WATCHLIST_INVENTORY);
          return;
        } else {
          setRoute(RouteConstants.LOGIN);
          return;
        }
      });
    });
  }, [props.location.search, setRoute]);

  return (
    <div className='full-height'>
      <LoadingComponent tip='Logging you in...'></LoadingComponent>
    </div>
  );
};


async function updateSuperUserRoleToUser(instance, userDetails, addRole) {
  try {
    let tokenResponse = await instance.acquireTokenSilent({
      account: instance.getActiveAccount(),
    });

    if (isHMSAdminGroupMember(tokenResponse.idTokenClaims)) {
      addRole = true; // Automatically grant role if internal user
    }

    const selectedUser = userDetails;
    if (!selectedUser) {
      console.error("User details not found.");
      message.error("User details not available.");
      return;
    }

    // Fetch all roles and get "SUPER USER" role
    let superUserRole = null;
    const roleResponse = await makeApiCallWithAuthentication(
      UrlConstants.ADMIN_GET_ALL_ROLES.USECASE,
      HttpConstants.GET_METHOD
    );

    if (roleResponse.status === 200) {
      const roles = roleResponse.data;
      superUserRole = roles.find((role) => role.name?.toLowerCase() === "super user");
    }

    if (!superUserRole) {
      console.error("Super User Role not found.");
      message.error("Super User role not found in system.");
      return;
    }

    // Modify user roles (add or remove "SUPER USER")
    let updatedRoles = selectedUser.roles.map(role => role.id);
    const hasSuperUserRole = updatedRoles.includes(superUserRole.id);

    if (addRole && !hasSuperUserRole) {
      updatedRoles.push(superUserRole.id);
    } else if (!addRole && hasSuperUserRole) {
      updatedRoles = updatedRoles.filter(roleId => roleId !== superUserRole.id);
    } else {
      console.log("No role change needed. Skipping API call.");
      return; // **Exit function without making an API call**
    }

    const params = {
      id: selectedUser.id,
      roles: updatedRoles,
    };

    // Update user role in backend only if there was a change
    const updateResponse = await makeApiCallWithAuthentication(
      UrlConstants.ADMIN_UPDATE_USER.USECASE,
      HttpConstants.PUT_METHOD,
      params
    );

    if (updateResponse.status === 200) {
      message.success(`User role ${addRole ? "added" : "removed"} successfully.`);
    } else {
      throw new Error("Failed to update user role.");
    }
  } catch (err) {
    console.error("Error updating role:", err);
    message.error("Couldn't update role, please try again later.");
  }
}

export default withRouter(inject('rootStore')(observer(RedirectScreen)));
